module.exports = __webpack_public_path__ + "static/mobile-2d4bd57b2210c656eebececbd45715be.png";